import { FeatureFlags } from "@utils/FeatureFlags/generated-flags";
import { useFlags } from "launchdarkly-react-client-sdk";

import { ApiReportReportStatusChoices } from "@api/graphql/types-and-hooks";
import { resolveReviewSetting } from "@components/ReportReview/reviewApproval";
import { useReportOptional } from "@providers/ReportProvider";

export const useIsApprovalRequired = (): boolean => {
  const flags = useFlags<FeatureFlags>();
  const report = useReportOptional()?.report;

  return (
    !!flags["report-peer-review"] &&
    !!report &&
    report.reportStatus !== ApiReportReportStatusChoices.Completed &&
    !!report.organization?.peerReviewEnabled &&
    resolveReviewSetting(
      report.reportTemplate?.requireApprovalBeforeExport,
      report.organization.requireApprovalBeforeExport,
    )
  );
};
